import * as config from "../../config";
import PrettyNumberTextField from "../common/PrettyNumberTextField";
import Grid from "@mui/material/Grid";
import FormattedDatePicker from "components/common/FormattedDatePicker";
import * as labels from "config.labels";
import React from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const PaymentTermsForm = ({ paymentTerms, setPaymentTerms }) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const updatePaymentTermsDays = (days) => {
    const newPaymentTerms = days == null ? null : { days };
    setPaymentTerms(newPaymentTerms);
  };

  return (
    <Grid item container xs={12} spacing={config.GRID_SPACING}>
      <Grid item xs={6}>
        <PrettyNumberTextField
          type={"text"}
          InputLabelProps={{ shrink: true }}
          InputProps={{ spellCheck: "false" }}
          label={translateLabel(labels.PAYMENT_TERMS_FORM_PAYMENT_DAYS, {
            default: "Payment Days",
          })}
          autoComplete={"off"}
          variant={"filled"}
          onChangeNumber={updatePaymentTermsDays}
          value={paymentTerms?.days ?? ""}
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <FormattedDatePicker
          label={translateLabel(labels.PAYMENT_TERMS_FORM_PAYMENT_DUE_DATE, {
            default: "Payment Due Date",
          })}
          value={paymentTerms?.dueDate ?? ""}
          fullWidth
          disabled
        />
      </Grid>
    </Grid>
  );
};

export default PaymentTermsForm;
